import React from "react"
import { Link } from "gatsby-plugin-modal-routing-3"
import { languageUtils } from "@utils/language"

const BtnVerModal = ({ name, to }) => {

  const cp = languageUtils.getCurrentPath()
  const p = cp.split('/')
  p.shift()
  p.shift()
  p.shift()
  const currentPath = [''].concat(p).join('/')

  return (
    <Link asModal to={`${currentPath}` + to}>
      <div className="btnVer-container">
        <div className="circle plus"></div>
        <div className="btn-name">{name}</div>
      </div>
    </Link>
  )
}

export default BtnVerModal
